export default "__VITE_ASSET__7aa82069__"